import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const evapotranspirationKc: typeof valueTypeRenderers.evapotranspirationKc = {
  label: () =>
    translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: unitConverter.evapotranspiration().titleWithoutUnit(),
      labelB: translate.phrases.unitSymbols('Kc'),
    }),
  block: () => {
    const { shortTitle } = unitConverter.evapotranspiration()
    const label = `${shortTitle()} ${translate.phrases.unitSymbols('Kc')}`

    return (v) => [
      {
        id: 'value',
        value: v === null ? translate.phrases.templates('-') : String(v),
        label,
      },
    ]
  },
}
